/*
 * On-demand loaders for the external editor runtimes (monaco-bundle /
 * codemirror-bundle). These used to be eager <script> tags in the host
 * page's head (~1MB+ parsed on every page load); now the editors chunk
 * pulls them in only when a CodeEditor/PillInput actually loads.
 *
 * The host page can override the URLs before uxp loads:
 *   window.UXPExternalBundles = { monaco: '...', codemirror: '...' }
 */
import { resolveResourceUrl } from '@utils';
const DEFAULT_URLS = {
    monaco: 'https://uxp.iviva.com/monaco-bundle/dist/monaco.min.js',
    codemirror: 'https://uxp.iviva.com/codemirror-bundle/dist/codemirror.min.js',
};
const GLOBALS = {
    monaco: 'UXPMonaco',
    codemirror: 'UXPCodeMirror',
};
const pending = {};
// Offline deployments can't reach the CDN; resolveResourceUrl maps the URL to
// the offline mirror (a 1:1 copy of the CDN), the same way the server's
// RewriteForOffline maps static HTML references.
function resolveBundleUrl(name) {
    var _a;
    const override = (_a = window.UXPExternalBundles) === null || _a === void 0 ? void 0 : _a[name];
    if (override)
        return override;
    return resolveResourceUrl(DEFAULT_URLS[name]);
}
export function ensureExternalBundle(name) {
    const globalKey = GLOBALS[name];
    if (window[globalKey])
        return Promise.resolve();
    const existing = pending[name];
    if (existing)
        return existing;
    const url = resolveBundleUrl(name);
    const promise = new Promise((resolve) => {
        const el = document.createElement('script');
        el.src = url;
        el.onload = () => resolve();
        el.onerror = () => {
            delete pending[name];
            console.error(`UXP: failed to load external bundle '${name}' from ${url}`);
            resolve(); // editor components handle the missing global themselves
        };
        document.head.appendChild(el);
    });
    pending[name] = promise;
    return promise;
}
